// White-label mode: todas las rutas de Captain estan deshabilitadas.
// Se omiten los imports a proposito: sin rutas no hay componentes que cargar,
// y asi el archivo no se rompe cuando upstream mueve o renombra vistas.
export const routes = [];
